export default __webpack_public_path__ + "static/martin-splitt-44148e346c7068d47059ab80f791cc4b.jpg";